<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="statistics"
      ref="list"
      unit="采购计划统计表"
      :page="page"
      :show-query="true"
      :query-params="params"
      :get-data-func="api.demandList"
      show-summary
      :summary-method="getSummary"
      urlHash="production/clothmanagement/statistics"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>

      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/production/clothmanagement/statistics/list.json";
import tableParam from "@/data/production/clothmanagement/statistics/query.json";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/pu/puPurchaseDemand").default,
      params: {
        ProductName: "",
        TradeUnitName: "",
        DocDateStart: "",
        DocDateEnd: "",
      },
    };
  },
  mounted() {},
  methods: {
    getSummary(param) {
      const { columns, data } = param;

      let labels = ["数量（主单位）", "金额", "累计执行数量（主单位）"];

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => {
          if (labels.includes(column.label)) {
            return Number(item[column.property]);
          }
        });

        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
  },
};
</script>
